export function decodeBase64Json(base64) {
  if (!base64) return null;

  try {
    // decode base64
    const binary = atob(base64);

    // تبدیل به byte array
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

    let jsonString;

    try {
      // تلاش برای UTF‑8
      jsonString = new TextDecoder("utf-8").decode(bytes);
      return JSON.parse(jsonString);
    } catch {
      // اگر UTF‑8 نبود → UTF‑16
      jsonString = new TextDecoder("utf-16le").decode(bytes);
      return JSON.parse(jsonString);
    }

  } catch (err) {
    console.error("Base64 JSON decode failed:", err);
    return null;
  }
}
